import { useDispatch, useSelector } from 'react-redux';
import { CloseButton } from 'foundations-components/transitional/components/CloseButton';
// @ts-ignore Untyped module
import { closePatagoniaSidebar } from 'ContentEditorUI/redux/actions/panelActions';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/components/View';
import { getIsUngatedForPegboards } from '../../redux/selectors/authSelectors';
import { getIsEditingGridLayouts } from '../../redux/selectors/moduleSelectors';
import { getActiveSidebarPanel } from '../../redux/selectors/sidebarSelectors';
import { SIDEBAR_PANELS } from '../../lib/sidebar/constants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PatagoniaSidebarHeader = ({
  headerText,
  subheaderText,
  onClose
}) => {
  const dispatch = useDispatch();
  const isUngatedForPegboards = useSelector(getIsUngatedForPegboards);
  const isEditingGridLayouts = useSelector(getIsEditingGridLayouts);
  const activeSidebarPanel = useSelector(getActiveSidebarPanel);
  const shouldHideCloseButton = isUngatedForPegboards && isEditingGridLayouts && (!activeSidebarPanel || activeSidebarPanel === SIDEBAR_PANELS.pageContents);
  function handleCloseSidebar() {
    UsageTracker.trackEditorInteraction({
      action: 'Toggle Sidebar',
      event: 'Close sidebar'
    });
    onClose === null || onClose === void 0 || onClose();
    dispatch(closePatagoniaSidebar());
  }
  return /*#__PURE__*/_jsxs(View, {
    borderBlockEndColor: "border-core-subtle",
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    children: [/*#__PURE__*/_jsxs(View, {
      marginBlockStart: "500",
      marginBlockEnd: "400",
      marginInline: "300",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h5",
        children: headerText
      }), subheaderText && /*#__PURE__*/_jsx(Text, {
        typography: "detail-200",
        marginBlockStart: "200",
        color: "text-tertiary-default",
        children: subheaderText
      })]
    }), !shouldHideCloseButton && /*#__PURE__*/_jsx(CloseButton, {
      color: "icon-core-subtle",
      "data-selenium": "save-and-close-sidebar",
      "data-test-id": "save-and-close-sidebar",
      onClick: handleCloseSidebar,
      size: "medium"
    })]
  });
};
export default PatagoniaSidebarHeader;